<template>
    <div class="main-visual">
        <swiper class="swiper" :options="swiperOptions">
            <template v-for="(slide, index) in slides">
                <swiper-slide :key="index">
                    <v-card flat tile :img="slide.image" class="main-visual__inner">
                        <div class="main-visual__text">
                            <template v-if="slide.title">
                                <tit-wrap class="tit-wrap--sm">
                                    <tit class="font-size-lg-32 font-weight-regular white--text">
                                        <div v-html="slide.title" />
                                    </tit>
                                </tit-wrap>
                            </template>
                            <template v-if="slide.text">
                                <txt class="txt--lg line-height-17 white--text">
                                    <div v-html="slide.text" />
                                </txt>
                            </template>
                        </div>
                    </v-card>
                </swiper-slide>
            </template>
        </swiper>
        <swiper-pagination-quarternary />
        <main-visual-requirement />
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import MainVisualRequirement from "@/components/client/main/main-visual/main-visual-requirement.vue";
import SwiperPaginationQuarternary from "@/components/publish/parents/swipers/swiper-pagination-quarternary.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";
import TitWrap from "@/components/publish/styles/typography/tit-wrap.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";
// import SwiperBtnWrapPrimary from "@/components/publish/parents/swipers/swiper-btn-wrap-primary.vue";
// import SwiperButtonPrimary from "@/components/publish/parents/swipers/swiper-button-primary.vue";
// import BtnArrowPrimary from "@/components/publish/parents/buttons/btn-arrow-primary.vue";

export default {
    components: {
        Swiper,
        SwiperSlide,
        MainVisualRequirement,
        SwiperPaginationQuarternary,
        Tit,
        TitWrap,
        Txt,
        // SwiperBtnWrapPrimary,
        // SwiperButtonPrimary,
        // BtnArrowPrimary,
    },
    props: {},
    data: () => ({
        swiperOptions: {
            effect: "fade",
            allowTouchMove: true,
            centeredSlides: true,
            spaceBetween: 0,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            speed: 500,
            loop: true,
        },
        slides: [
            {
                title: "입주민 전용 대형 피트니스와 <br />서울시가 조망되는 21층 작은 도서관에서 즐기는 <br /><strong>청년의 라이프 스타일</strong>",
                text: "3층 피트니스(65평), 21층 작은 도서관(54평)과 코인세탁실 등 <br />입주민 전용 커뮤니티시설을 갖춰 세이지움 개봉에서 <br />한층 여유 있는 생활을 즐길 수 있습니다.",
                image: "/images/main/visual-1.jpg",
            },
            {
                title: "대형 쇼핑몰과 목감천-안양천 등 자연환경을 <br />함께 즐길 수 있는 편리한 생활 입지",
                text: "차량 9분 내 대형 할인매장(아이파크몰, 코스트코), 광명시장, <br />목감천, 개웅산이 위치해 있어 생활 편의와 휴식을 함께 누릴 수 있습니다.",
                image: "/images/main/visual-2.jpg",
            },
            {
                title: "구로-가산 디지털국가산업단지, 여의도 등 <br />주요 업무지구와 인접한 <strong>최적의 직주근접 환경</strong>",
                text: "1호선 개봉역, 7호선 광명사거리역을 통해 주요 업무지구에 <br />빠르게 이동할 수 있어 저녁이 있는 청년의 삶을 누릴 수 있습니다.",
                image: "/images/main/visual-3.jpg",
            },
        ],
    }),
};
</script>

<style lang="scss" scoped>
.main-visual {
    max-width: 1920px;
    max-height: 880px;
    margin: 0 auto;
    position: relative;
    .swiper-container {
        position: static;
    }
    &__inner {
        height: 360px;
        padding: 50px var(--container-gutter);
        box-sizing: border-box;
    }
}
.swiper-pagination {
    top: 340px;
    bottom: initial;
    color: #fff;
}
@media (min-width: 1024px) {
    .main-visual {
        margin-top: var(--header-height);
    }
}
@media (min-width: 1200px) {
    .main-visual {
        height: calc(100vh - var(--header-height));
        margin-top: var(--header-height);
        display: flex;
        &__inner {
            height: 100%;
            padding: 240px 0 0 calc(240 / 1374 * 100%);
        }
    }
    .swiper-pagination {
        top: initial;
        bottom: 40px;
    }
}
</style>
